import { useContext } from 'react';
import { AccountContext } from 'src/providers/account/context';
import { User } from 'src/utils/gql/types';

export interface AccountContextType {
  user: User;
}

export const useAccount = (): AccountContextType => useContext(AccountContext);
